/* eslint-disable max-len */

import React from 'react';
import type { SVGProps } from 'react';

export interface PositionBottomProps extends SVGProps<SVGSVGElement> {
  color?: string;
}

export const PositionBottom: React.FC<PositionBottomProps> = ({ color = 'none', ...props }) => {
  return (
    <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.2498 18.7485C20.2498 18.3343 19.914 17.9985 19.4998 17.9985H4.5C4.08579 17.9985 3.75 18.3343 3.75 18.7485C3.75 19.1627 4.08579 19.4985 4.5 19.4985H19.4998C19.914 19.4985 20.2498 19.1627 20.2498 18.7485Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4697 17.0325C11.7626 17.3254 12.2374 17.3254 12.5303 17.0325L16.2504 13.3126C16.5433 13.0197 16.5433 12.5448 16.2504 12.2519C15.9575 11.959 15.4826 11.959 15.1897 12.2519L12 15.4415L8.81036 12.2519C8.51747 11.959 8.04259 11.959 7.7497 12.2519C7.45681 12.5448 7.45681 13.0197 7.7497 13.3126L11.4697 17.0325Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 16.3923C12.4142 16.3923 12.75 16.0565 12.75 15.6423V6.0022C12.75 5.58798 12.4142 5.2522 12 5.2522C11.5858 5.2522 11.25 5.58798 11.25 6.0022L11.25 15.6423C11.25 16.0565 11.5858 16.3923 12 16.3923Z"
        fill={color}
      />
    </svg>
  );
};
